import React from 'react';
import { Redirect } from 'react-router-dom';

const PortfolioNftRedirect = () => <Redirect to="/portfolio" />;

export default PortfolioNftRedirect;
